module.exports = __webpack_public_path__ + "img/logo-company.dfdf6429.png";